export const bg = "var(--seed-color-manner-temp-l6-bg)";
export const text = "var(--seed-color-manner-temp-l6-text)";